export const MiniEmp = ({ name, cId, img }) => {
  return {
    name,
    cId,
    img,
  };
};
export const EmpAttendDisplay = ({
  _id,
  department,
  post,
  farm,
  salaryNomina,
  salaryAyco,
  hourNomina,
  hourAyco,
  extraHours,
  name,
  cId,
  img,
}) => ({
  _id,
  department,
  post,
  farm,
  salaryNomina,
  salaryAyco,
  hourNomina,
  hourAyco,
  extraHours,
  name,
  cId,
  img,
});
// TODO: CONVERT AND DO SAFE TYPES
export const EmpAttend = ({
  _id,
  department,
  post,
  farm,
  salaryNomina,
  salaryAyco,
  hourNomina,
  hourAyco,
  extraHours,
}) => ({
  _id,
  department,
  post,
  farm,
  salaryNomina,
  salaryAyco,
  hourNomina,
  hourAyco,
  extraHours,
});

// export const empAttend = ({ name, cId, img, }) => {
//     return {
//         name,
//         cId,
//         img
//     }
// }
